import IconClipboardGradient, {
	IconClipboardGradientProps as _IconClipboardGradientProps,
} from './IconClipboardGradient';

export { IconClipboardGradient };
export type IconClipboardGradientProps = _IconClipboardGradientProps;
